module.exports = __webpack_public_path__ + "static/media/odoo.64f18fb4.png";